module.exports = __webpack_public_path__ + "static/img/bgimg5-3.5b408d05.png";